import { render, staticRenderFns } from "./GraficaVolumenesNsv.vue?vue&type=template&id=37f09bbc"
import script from "./GraficaVolumenesNsv.vue?vue&type=script&lang=js"
export * from "./GraficaVolumenesNsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports